import D28dRoutinesMaster from '../admin/D28dRoutinesMaster';

/** Rutinas propias del gimnasio virtual (scope gym_wl, sin catálogo D28D). */
export default function GymMastersRoutines({ onBack, scopeGymId = null }) {
  return (
    <D28dRoutinesMaster
      variant="gym"
      scopeGymId={scopeGymId}
      onBack={onBack}
    />
  );
}
